import React, { useEffect, useState, useMemo } from 'react';
import useFetchYouTubeResources from '../api/useFetchYouTubeResources';
import { audioLinks, videoLinks } from '../api/youtubeLinks';


import { motion, AnimatePresence } from "framer-motion"
import {
  Book,
  Video,
  Headphones,
  Download,
  Search,
  Filter,
  Grid3X3,
  List,
  Star,
  Clock,
  Eye,
  TrendingUp,
  Calendar,
  Play,
  BookOpen,
  Volume2,
  ChevronDown,
  ThumbsUp,
  MessageCircle
} from "lucide-react"
import ImagesDev from '../api/images';
import { fetchLibraryItems } from '../api/adminService';





function Library_() {
  const [activeTab, setActiveTab] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const resourcesFromHook = useFetchYouTubeResources(videoLinks, audioLinks);
  const [resources, setResources] = useState([]);


  useEffect(() => {
    setResources(resourcesFromHook);
  }, [resourcesFromHook])

  const resources_template = [
    {
      id: 1,
      title: "Walking in the Spirit",
      type: "video",
      duration: "45 mins",
      thumbnail: "https://images.unsplash.com/photo-1585314062340-f1a5a7c9328d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      description: "Learn how to maintain a Spirit-led life in today's world.",
    },
    {
      id: 2,
      title: "Understanding Biblical Prophecy",
      type: "book",
      pages: 120,
      thumbnail: "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      description: "A comprehensive guide to understanding biblical prophecies.",
    },
    {
      id: 3,
      title: "Prayer Warriors Podcast",
      type: "audio",
      duration: "30 mins",
      thumbnail: "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      description: "Weekly discussions on the power of prayer.",
    },
    // Add more resources as needed
  ];
  const resources_ = [];

  const categories = [
    { id: 'all', label: 'All Resources', icon: Filter },
    { id: 'video', label: 'Videos', icon: Video },
    { id: 'book', label: 'Books', icon: Book },
    { id: 'audio', label: 'Audio', icon: Headphones },
  ];

  const filteredResources = resources.filter(resource =>
    (activeTab === 'all' || resource.type === activeTab) &&
    resource.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white pt-24"
    >
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto mb-12 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Resource Library</h1>
          <p className="text-xl text-gray-300">Access our collection of spiritual resources to deepen your faith journey</p>
        </div>

        {/* Search and Filter */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1 relative">
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search resources..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-12 pr-4 py-3 bg-white/10 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
              />
            </div>
            <div className="flex gap-2">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setActiveTab(category.id)}
                  className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-colors ${activeTab === category.id
                    ? 'bg-amber-600 text-white'
                    : 'bg-white/10 text-gray-300 hover:bg-white/20'
                    }`}
                >
                  <category.icon className="w-4 h-4" />
                  <span className="hidden md:inline">{category.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Resources Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredResources.map((resource) => (
            <motion.div
              key={resource.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-white/5 rounded-lg overflow-hidden backdrop-blur-sm hover:bg-white/10 transition-colors"
            >
              <div className="relative h-48">
                <img
                  src={resource.thumbnail}
                  alt={resource.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 right-4 px-3 py-1 bg-black/50 rounded-full text-sm backdrop-blur-sm">
                  {resource.type === 'video' && <Video className="w-4 h-4" />}
                  {resource.type === 'book' && <Book className="w-4 h-4" />}
                  {resource.type === 'audio' && <Headphones className="w-4 h-4" />}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-2">{resource.title}</h3>
                <p className="text-gray-400 mb-4">{resource.description.slice(0, 100)}{resource.description.length >= 100 ? "..." : ""}</p>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-400">
                    {resource.duration || `${resource.pages} pages`}
                  </span>
                  <button className="flex items-center gap-2 px-4 py-2 bg-amber-600 rounded-lg hover:bg-amber-700 transition-colors">
                    <Download className="w-4 h-4" />
                    Access
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
}





function Library() {
  const [activeTab, setActiveTab] = useState("all")
  const [searchQuery, setSearchQuery] = useState("")
  const [sortBy, setSortBy] = useState("newest")
  const [viewMode, setViewMode] = useState("grid")
  const [showFeatured, setShowFeatured] = useState(false)
  const [sortDropdownOpen, setSortDropdownOpen] = useState(false);
  const [sortDropdownOpen2, setSortDropdownOpen2] = useState(false);
  const [sampleResources, setSampleResources] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 12;


  const goToResource = (item) => {
    if (item.library_type === "bst") {
      window.location.href = `/study?id=${item.id}`;
    } else {
      window.open(item.youtube_url, "blank")
    }
  }

  const goToAsk = (item) => {
    window.location.href = `/ask?id=${item.id}`;
  }




  const categories = [
    { id: "all", label: "All Resources", icon: Filter, count: sampleResources.length },
    // { id: "bst", label: "BST", icon: Video, count: sampleResources.filter((r) => r.library_type === "bst").length },
    { id: "event", label: "Event", icon: Video, count: sampleResources.filter((r) => r.library_type === "event").length },
    { id: "live", label: "Live", icon: Video, count: sampleResources.filter((r) => r.library_type === "live").length },
    { id: "video", label: "Videos", icon: Video, count: sampleResources.filter((r) => r.library_type === "video").length },
    { id: "book", label: "Books", icon: Book, count: sampleResources.filter((r) => r.library_type === "book").length },
    { id: "audio", label: "Audio", icon: Headphones, count: sampleResources.filter((r) => r.library_type === "audio").length },
  ]

  const sortOptions = [
    { value: "newest", label: "Newest First" },
    { value: "oldest", label: "Oldest First" },
    { value: "popular", label: "Most Popular" },
    { value: "rating", label: "Highest Rated" },
    { value: "title", label: "Title A-Z" },
  ]

  const filteredAndSortedResources = useMemo(() => {
    const filtered = sampleResources.filter((resource) => {
      const matchesTab = activeTab === "all" || resource.library_type === activeTab
      const matchesSearch =
        resource.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        resource.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
        resource.tags.some((tag) => tag.toLowerCase().includes(searchQuery.toLowerCase()))
      const matchesFeatured = !showFeatured || resource.library_type === "bst"

      return matchesTab && matchesSearch && matchesFeatured
    })

    // Sort resources
    filtered.sort((a, b) => {
      switch (sortBy) {
        case "newest":
          return new Date(b.date).getTime() - new Date(a.date).getTime()
        case "oldest":
          return new Date(a.date).getTime() - new Date(b.date).getTime()
        case "popular":
          return b.views - a.views
        case "rating":
          return b.rating - a.rating
        case "title":
          return a.title.localeCompare(b.title)
        default:
          return 0
      }
    })

    return filtered
  }, [sampleResources, activeTab, searchQuery, sortBy, showFeatured])

  const totalPages = Math.ceil(filteredAndSortedResources.length / ITEMS_PER_PAGE)
  const paginatedResources = filteredAndSortedResources.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  )

  useEffect(() => {
    const fetchAllLibrary = async () => {
      await fetchLibraryItems((currentList) => {
        setSampleResources(currentList); // Updates list as it loads
      });
    };

    fetchAllLibrary();
  }, []);

  useEffect(() => {
    setCurrentPage(1)
  }, [activeTab, searchQuery, sortBy, showFeatured])

  const getResourceIcon = (type) => {
    switch (type) {
      case "video":
        return Play
      case "book":
        return BookOpen
      case "audio":
        return Volume2
      default:
        return Book
    }
  }

  const getButtonName = (type) => {
    switch (type) {
      case "video":
        return "Play"
      case "book":
        return "Access"
      case "audio":
        return "Play"
      case "event":
        return "Study"
      case "bst":
        return "Study"
      case "live":
        return "Watch"
      default:
        return "Access"
    }
  }

  const formatViews = (views) => {
    if (views >= 1000) {
      return `${(views / 1000).toFixed(1)}K`
    }
    return views ? views.toString() : ""
  }

  const getSortLabel = (value) => {
    return sortOptions.find((option) => option.value === value)?.label || "Sort by"
  }
  const getActiveTab = (value) => {
    return categories.find((option) => option.id === value) || { label: "All Resources", count: 0, icon: Filter }
  }
  const defaultActiveTab = getActiveTab(activeTab);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white pt-24">
      {/* Hero Section */}
      {/* <div className="absolute inset-0 bg-gradient-to-r from-amber-600/20 to-pink-600/20 top-0" /> */}
      <div className="absolute inset-0 opacity-30 top-0"
        style={{ background: `url(${ImagesDev.heroImagesDesk[2]}) center`, backgroundSize: "cover" }} />
      <div className="relative overflow-hidden">
        <div className="relative container mx-auto px-4 pt-24 pb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl mx-auto text-center"
          >
            <h1 className="text-5xl md:text-7xl font-bold bg-gradient-to-r from-white to-orange-200 bg-clip-text text-transparent mb-6 animate-pulse-slow">
              TSO Content Hub
            </h1>
            <p className="text-xl md:text-2xl text-slate-300 mb-8 leading-relaxed">
              Discover a world of spiritual growth through our curated collection of videos, books, and audio content
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm text-slate-400">
              <div className="flex items-center gap-2">
                <TrendingUp className="w-4 h-4" />
                <span>{sampleResources.length} Resources</span>
              </div>
              <div className="flex items-center gap-2">
                <Star className="w-4 h-4" />
                <span>4.8 Average Rating</span>
              </div>
              <div className="flex items-center gap-2">
                <Eye className="w-4 h-4" />
                <span>100K+ Views</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="container mx-auto px-4 pb-16">
        {/* Search and Controls */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="max-w-6xl mx-auto mb-4 md:mb-12"
        >
          <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-lg p-6">
            <div className="flex flex-col lg:flex-row gap-4">
              {/* Search */}
              <div className="flex-1 relative">
                <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Search resources, topics, or authors..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent h-12"
                />
              </div>

              {/* Sort Dropdown */}
              <div className="relative">
                <button
                  onClick={() => { setSortDropdownOpen(!sortDropdownOpen); setSortDropdownOpen2(false) }}
                  className="w-full lg:w-48 h-12 px-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-amber-500 flex items-center justify-between"
                >
                  <span>{getSortLabel(sortBy)}</span>
                  <ChevronDown className={`w-4 h-4 transition-transform ${sortDropdownOpen ? "rotate-180" : ""}`} />
                </button>
                {sortDropdownOpen && (
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0 }} className="absolute -top-14 left-0 right-0 mt-1 bg-slate-800/90 backdrop-blur-lg border border-white/10 rounded-lg shadow-xl z-50">
                    {sortOptions.map((option) => (
                      <button
                        key={option.value}
                        onClick={() => {
                          setSortBy(option.value)
                          setSortDropdownOpen(false)
                        }}
                        className="w-full px-4 py-3 text-left text-white hover:bg-white/10 first:rounded-t-lg last:rounded-b-lg transition-colors"
                      >
                        {option.label}
                      </button>
                    ))}
                  </motion.div>
                )}
              </div>

              {/* View Mode */}
              <div className="flex gap-2">
                <button
                  onClick={() => setViewMode("grid")}
                  className={`h-12 w-12 rounded-lg flex items-center justify-center transition-colors ${viewMode === "grid"
                    ? "bg-amber-600 text-white"
                    : "bg-white/5 border border-white/10 text-slate-400 hover:bg-white/10"
                    }`}
                >
                  <Grid3X3 className="w-5 h-5" />
                </button>
                <button
                  onClick={() => setViewMode("list")}
                  className={`h-12 w-12 rounded-lg flex items-center justify-center transition-colors ${viewMode === "list"
                    ? "bg-amber-600 text-white"
                    : "bg-white/5 border border-white/10 text-slate-400 hover:bg-white/10"
                    }`}
                >
                  <List className="w-5 h-5" />
                </button>
              </div>
            </div>

            {/* Featured Toggle */}
            <div className="flex items-center gap-4 mt-4 pt-4 border-t border-white/10">
              <button
                onClick={() => setShowFeatured(!showFeatured)}
                className={`h-8 px-4 rounded-lg flex items-center gap-2 transition-colors ${showFeatured
                  ? "bg-amber-600 text-white"
                  : "bg-white/5 border border-white/10 text-slate-400 hover:bg-white/10"
                  }`}
              >
                <Star className="w-4 h-4" />
                BST Only
              </button>
              <span className="text-sm text-slate-400">{filteredAndSortedResources.length} resources found</span>
            </div>
          </div>
        </motion.div>

        {/* Category Tabs Desktop View */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="max-w-6xl mx-auto mb-12 hidden md:grid"
        >
          <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-lg p-2">
            <div className="grid grid-cols-3 lg:grid-cols-6 gap-2">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setActiveTab(category.id)}
                  className={`flex items-center gap-2 py-3 px-4 rounded-lg transition-colors ${activeTab === category.id
                    ? "bg-white/10 text-white"
                    : "text-slate-400 hover:bg-white/5 hover:text-white"
                    }`}
                >
                  <category.icon className="w-4 h-4" />
                  <span className="hidden sm:inline text-xs">{category.label}</span>
                  <span className="ml-auto bg-white/10 text-white border-0 px-2 py-1 rounded-full text-xs">
                    {category.count}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </motion.div>

        {/* Category Tabs Mobile View */}
        <div className="relative grid md:hidden mb-6">
          <button
            onClick={() => { setSortDropdownOpen2(!sortDropdownOpen2); setSortDropdownOpen(false) }}
            className="w-full lg:w-48 h-12 px-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-amber-500 flex items-center justify-between"
          >
            <div className='flex items-center gap-1'>
              <defaultActiveTab.icon className="w-4 h-4" />
              <span>{defaultActiveTab.label}</span>
            </div>
            <div className='flex items-center gap-1'>
              <span className="ml-auto bg-white/10 text-white border-0 px-2 py-1 rounded-full text-xs">
                {defaultActiveTab.count}
              </span>
              <ChevronDown className={`w-4 h-4 transition-transform ${sortDropdownOpen2 ? "rotate-180" : ""}`} />
            </div>
          </button>
          {sortDropdownOpen2 && (
            <div className="absolute top-full left-0 right-0 mt-1 bg-slate-600/60 backdrop-blur-lg border border-white/10 rounded-lg shadow-xl z-50">
              {categories.map((option) => (
                <button
                  key={option.value}
                  onClick={() => {
                    setActiveTab(option.id)
                    setSortDropdownOpen2(false)
                  }}
                  className="flex items-center justify-between gap-2 w-full px-4 py-3 text-left text-white hover:bg-white/10 first:rounded-t-lg last:rounded-b-lg transition-colors"
                >
                  <span className="flex items-center gap-2">
                    <option.icon className="w-3 h-3" />
                    {option.label}
                  </span>

                  <span className="ml-auto bg-white/10 text-white border-0 px-2 py-1 rounded-full text-[10px]">
                    {option.count}
                  </span>
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Resources Grid/List */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="max-w-6xl mx-auto"
        >
          <AnimatePresence mode="wait">
            {filteredAndSortedResources.length === 0 ? (
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                className="text-center py-16"
              >
                <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-white/5 flex items-center justify-center">
                  <Search className="w-12 h-12 text-slate-400" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">No resources found</h3>
                <p className="text-slate-400 mb-6">Try adjusting your search or filter criteria</p>
                <button
                  onClick={() => {
                    setSearchQuery("")
                    setActiveTab("all")
                    setShowFeatured(false)
                  }}
                  className="px-6 py-3 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors cursor-pointer"
                >
                  Clear Filters
                </button>
              </motion.div>
            ) : (
              <div className={viewMode === "grid" ? "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-8" : "space-y-6"}>
                {paginatedResources.map((resource, index) => {
                  const ResourceIcon = getResourceIcon(resource.library_type);
                  const buttonName = getButtonName(resource.library_type);

                  return (
                    <motion.div
                      key={resource.id}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: index * 0.1 }}
                      className="group"
                    >
                      <div
                        className={`
                        bg-white/5 backdrop-blur-xl border border-white/10 rounded-lg overflow-hidden
                        hover:bg-white/10 transition-all duration-300 hover:scale-[1.02]
                        hover:shadow-2xl hover:shadow-amber-500/20 h-full relative
                        ${viewMode === "list" ? "flex flex-row" : ""}
                      `}
                      >
                        <div className={`relative ${viewMode === "list" ? "w-36 md:w-48 flex-shrink-0" : "h-36"}`}>
                          <img
                            src={resource.thumbnail || "/placeholder.svg"}
                            alt={resource.title}
                            className="w-full h-full object-cover"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />

                          {/* Resource Type Badge */}
                          <div className="absolute top-4 left-4">
                            <span className="bg-black/50 backdrop-blur-sm border-0 text-white px-3 py-1 rounded-full text-sm flex items-center gap-1">
                              <ResourceIcon className="w-3 h-3" />
                              {resource.library_type}
                            </span>
                          </div>

                          {/* Featured Badge */}
                          {resource.library_type === "bst" && (
                            <div className="absolute top-4 right-4">
                              <span className="bg-gradient-to-r from-yellow-500 to-orange-500 border-0 text-white px-3 py-1 rounded-full text-sm flex items-center gap-1">
                                <Star className="w-3 h-3" />
                                BST
                              </span>
                            </div>
                          )}

                          {/* Play/Access Overlay */}
                          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                            <button onClick={() => goToResource(resource)}
                              className="bg-white/20 backdrop-blur-sm hover:bg-white/30 px-6 py-3 rounded-lg text-white font-medium flex items-center gap-2 transition-colors">
                              <ResourceIcon className="w-5 h-5" />
                              {/* Access */} {buttonName}
                            </button>
                          </div>
                        </div>

                        <div onClick={() => goToResource(resource)} className='bg-white/0 h-[100%] w-[100%] absolute top-0 left-0 cursor-pointer'></div>

                        <div className={`p-2 md:p-6 flex-1 ${viewMode === "list" ? "w-6 md:w-full" : ""}`}>
                          <div className="flex items-start justify-between mb-1 md:mb-3">
                            <h3 className="text-sm md:text-md font-bold text-white group-hover:text-amber-200 transition-colors line-clamp-2">
                              {resource.title}
                            </h3>
                          </div>

                          <p className={`text-slate-300 mb-2 md:mb-4 line-clamp-2 text-xs md:text-sm
                          ${viewMode === "list" ? "hidden md:line-clamp-2" : ""}
                            `}>{resource.description}</p>

                          <div className="flex flex-col lg:flex-row gap-1 lg:gap-4 mb-2 lg:mb-4">
                            <div className="flex items-center gap-4  text-[10px] text-slate-400">
                              <div className="flex items-center gap-1">
                                <Clock className="w-4 h-4" />
                                {resource.duration || `${resource.pages} pages`}
                              </div>
                              <div className="flex items-center gap-1">
                                <Eye className="w-4 h-4" />
                                {formatViews(resource.views)}
                              </div>
                            </div>
                            <div className="hidden lg:flex items-center gap-4  text-[10px] text-slate-400">
                              <div className="flex items-center gap-1">
                                <ThumbsUp className="w-4 h-4" />
                                {formatViews(resource.likes)}
                              </div>
                              <div className="flex items-center gap-1">
                                <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                                {resource.rating}
                              </div>
                            </div>
                          </div>

                          <div className="relative flex flex-col-reverse lg:flex-row lg:items-center justify-between gap-3">
                            {resource.library_type === "bst" ?
                              <button
                                onClick={() => goToAsk(resource)}
                                className="mb-1 inline-flex animate-pulse items-center gap-2 bg-gradient-to-r from-orange-600 to-blue-600 hover:from-orange-700 hover:to-blue-700 px-4 py-2 rounded-lg text-white font-medium transition-all duration-300"
                              >
                                <MessageCircle className="w-5 h-5" />
                                <span>Ask</span>
                              </button>
                              :
                              <div>
                                <p className="mt-2 lg:mt-0 text-sm text-slate-300 font-medium">{resource.author}</p>
                                <div className="flex items-center gap-1 text-xs text-slate-400">
                                  <Calendar className="w-3 h-3" />
                                  {new Date(resource.date).toLocaleDateString()}
                                </div>
                              </div>
                            }

                            <button
                              onClick={() => goToResource(resource)}
                              className="bg-gradient-to-r from-amber-600 to-pink-600 hover:from-amber-700 hover:to-pink-700 px-4 py-2 rounded-lg text-white font-medium flex items-center gap-2 transition-colors">
                              <ResourceIcon className="w-3 h-3" />
                              {/* Access */} {buttonName}
                            </button>
                          </div>

                          {/* Tags */}
                          <div className="flex flex-wrap gap-2 mt-4">
                            {resource.tags?.map((tag) => (
                              <span
                                key={tag}
                                className="border border-white/20 text-slate-300 text-xs px-2 py-1 rounded-md"
                              >
                                {tag}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  )
                })}
              </div>
            )}
          </AnimatePresence>
        </motion.div>

        {/* Pagination */}
        <div className="flex flex-col sm:flex-row items-center justify-between mt-8 gap-4">
          <p className="text-sm text-slate-400">
            Showing {(currentPage - 1) * ITEMS_PER_PAGE + 1}–
            {Math.min(currentPage * ITEMS_PER_PAGE, filteredAndSortedResources.length)} of {filteredAndSortedResources.length}
          </p>

          <div className="flex flex-wrap items-center gap-2">
            <button
              onClick={() => setCurrentPage(1)}
              disabled={currentPage === 1}
              className="px-3 py-1 rounded-lg border border-white/10 text-slate-300 hover:bg-white/10 disabled:opacity-30"
            >
              First
            </button>
            <button
              onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
              disabled={currentPage === 1}
              className="px-3 py-1 rounded-lg border border-white/10 text-slate-300 hover:bg-white/10 disabled:opacity-30"
            >
              Prev
            </button>

            {[...Array(totalPages)].map((_, idx) => {
              const page = idx + 1
              return (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={`px-3 py-1 rounded-lg border text-sm ${currentPage === page
                    ? "bg-amber-600 text-white border-amber-600"
                    : "border-white/10 text-slate-300 hover:bg-white/10"
                    }`}
                >
                  {page}
                </button>
              )
            }).slice(
              Math.max(0, currentPage - 3),
              Math.min(totalPages, currentPage + 2)
            )}

            <button
              onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}
              disabled={currentPage === totalPages}
              className="px-3 py-1 rounded-lg border border-white/10 text-slate-300 hover:bg-white/10 disabled:opacity-30"
            >
              Next
            </button>
            <button
              onClick={() => setCurrentPage(totalPages)}
              disabled={currentPage === totalPages}
              className="px-3 py-1 rounded-lg border border-white/10 text-slate-300 hover:bg-white/10 disabled:opacity-30"
            >
              Last
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Library;